import { roundTo } from "./tillHelpers";

/**
 * BUG-2620: amounts of a fired line filled into the cart from the server's lines[] (a line the
 * saved cart snapshot did not have, e.g. added from the waiter app).
 *
 * The waiter app's orderLine meta holds nettotal WITHOUT tax (= linenet) and realPrice/salePrice
 * WITH tax. Copied as-is, bill 1 of HMRS/11396 left out the tax of Masala Chaas + Mineral Water
 * (Rs 1421.02 instead of Rs 1426.44) and printed 103.95 as the Chaas price. Only a line showing
 * that pattern (nettotal below linenet + linetax) is corrected — a POS line keeps its values:
 *  - nettotal: the server's lineGross (with tax), else linenet + linetax;
 *  - taxAmount: linetax;
 *  - realPrice/salePrice: the server's net unitPrice, on a tax-exclusive till only.
 * Returns the item to use and whether it was corrected.
 */
export const correctWaiterLineAmounts = (item, meta, serverLine, { precision = 2, isTaxIncluded } = {}) => {
  const metaNet = Number(meta?.linenet);
  const metaTax = Number(meta?.linetax);
  if (!Number.isFinite(metaNet) || !Number.isFinite(metaTax) || metaTax <= 0) return { item, corrected: false };
  if (!(Number(item?.nettotal) + 0.01 < metaNet + metaTax)) return { item, corrected: false };
  const serverGross = Number(serverLine?.lineGross);
  const next = {
    ...item,
    nettotal: roundTo(serverGross > 0 ? serverGross : metaNet + metaTax, precision),
    taxAmount: roundTo(metaTax, precision),
  };
  if (isTaxIncluded === "N" && Number(serverLine?.unitPrice) > 0) {
    next.realPrice = Number(serverLine.unitPrice);
    next.salePrice = Number(serverLine.unitPrice);
  }
  return { item: next, corrected: true };
};
